<div class="login-wrapper">
  <app-loading-indicator [isLoading]="isLoading" loadingMessage=""></app-loading-indicator>

  <div class="login-container" *ngIf="!isLoading">
    <div class="login-button"><button type="button" class="btn btn-primary btn-fw btn-login" (click)="login()">Log In</button></div>
    <div class="login-image"><img src="assets/images/login/image.svg" alt="Image of 3 people hanging a star" /></div>
    <div class="login-text"><img src="assets/images/login/text.svg" alt="The text Ask. Learn. Share." /></div>
  </div>
  <div class="login-logo" *ngIf="!isLoading"><img src="assets/images/logos/blue-logo.svg" alt="Workbench Logo" style="cursor:pointer" /></div>
</div>
